import $ from 'jquery';
import 'bootstrap/js/dist/modal.js';

const SELECTOR_VIDEO_PLAY = '[data-video-play]';
const SELECTOR_VIDEO_MODAL_PLAY = '[data-video-modal-play]';
const SELECTOR_VIDEO_EMBED = '[data-video-item]';
const ATTRIBUTE_VIDEO_MODAL_PLAY = 'video-modal-play';
const ATTRIBUTE_VIDEO_URL = 'video-url';
const ATTRIBUTE_VIDEO_MODAL_CLICK_AREA = 'data-video-modal-click-area';

export function initVideoHandling() {
  /*
   * General Videos
   */
  const $playButtons = $(SELECTOR_VIDEO_PLAY);

  // Delegated event, f.e. for slide items within a loop
  $(document).on('click', SELECTOR_VIDEO_PLAY, (event) => {
    const $playButton = $(event.currentTarget);
    const $videoEmbed = $playButton.prevAll(SELECTOR_VIDEO_EMBED);
    const videoUrl = $playButton.data(ATTRIBUTE_VIDEO_URL);

    // Inject
    $videoEmbed.attr('src', videoUrl);

    // Hide
    $playButton.addClass('d-none')
  });

  // Check before enable
  $playButtons.each((index, element) => {
    const $playButton = $(element);
    const $videoEmbed = $playButton.prevAll(SELECTOR_VIDEO_EMBED);
    const videoUrl = $playButton.data(ATTRIBUTE_VIDEO_URL) || false;

    if ($videoEmbed.length !== 1 || videoUrl === false) {
      // Do nothing
      return;
    }

    // Enable button
    $playButton.removeClass('d-none');
  });


  /*
   * Video Modals
   */
  const $modalPlayButtons = $(SELECTOR_VIDEO_MODAL_PLAY);

  // Delegated event, f.e. for slide items within a loop
  $(document).on('click', `${SELECTOR_VIDEO_MODAL_PLAY}, [${ATTRIBUTE_VIDEO_MODAL_CLICK_AREA}]`, (event) => {
    event.stopPropagation();

    const $element = $(event.currentTarget);
    const isElementClickArea = typeof $element.attr(ATTRIBUTE_VIDEO_MODAL_CLICK_AREA) === 'string';
    let $playButton;

    if (isElementClickArea) {
      $playButton = $element.find(SELECTOR_VIDEO_MODAL_PLAY);
    } else {
      $playButton = $element;
    }

    const $modal = $($playButton.data(ATTRIBUTE_VIDEO_MODAL_PLAY));
    const videoUrl = $playButton.data(ATTRIBUTE_VIDEO_URL);
    const $videoEmbed = $modal.find(SELECTOR_VIDEO_EMBED);

    // Inject
    $videoEmbed.attr('src', videoUrl);

    // Show
    $modal.modal('show');
  });

  // Check before enable
  $modalPlayButtons.each((index, element) => {
    const $playButton = $(element);
    const $modal = $($playButton.data(ATTRIBUTE_VIDEO_MODAL_PLAY));
    const videoUrl = $playButton.data(ATTRIBUTE_VIDEO_URL) || false;

    if ($modal.length !== 1 || videoUrl === false) {
      // Do nothing
      return;
    }

    const $videoEmbed = $modal.find(SELECTOR_VIDEO_EMBED);

    // Close
    $modal.on('hide.bs.modal', function() {
      // Cleanup
      $videoEmbed.attr('src', '');
    });

    // Enable button
    $playButton.removeClass('d-none');
  });
}
